// src/service/userService.ts
 
import { User } from "../types/user";
import api from "./api"; 

// Kullanıcı bilgilerini güncelleme
interface UpdateUserPayload {
  name?: string;
  email?: string;
  password?: string;
}

export const updateUserRequest = async (payload: UpdateUserPayload): Promise<User> => {
    console.log(payload)
  const res = await api.put("/user/fromAuth", payload);
  return res.data;
};

// Mevcut kullanıcıyı getirme (optional)
export const getUserRequest = async (): Promise<User> => {
  const res = await api.get("/user");
  return res.data;
};
 